import { render, staticRenderFns } from "./Konva.vue?vue&type=template&id=be28017c&scoped=true"
import script from "./Konva.vue?vue&type=script&lang=js"
export * from "./Konva.vue?vue&type=script&lang=js"
import style0 from "./Konva.vue?vue&type=style&index=0&id=be28017c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be28017c",
  null
  
)

export default component.exports